import configureReducers from './Reducers';
import configureActions from './Actions';

const configureRedux = async (services) => {
    return {
        actions: configureActions(services),
        reducers: configureReducers(services),
    };
};

export default configureRedux;
